import dataLayer from './dataLayer'


function avatarMenuClick (text) {
  dataLayer.add({
    event : 'topNavigationKonto',
    target : text
  })
}

function menuClick (isHamburger, text) {
  const event = isHamburger ? 'topNavigationHamburgarLink' : 'topNavigation'
  const eventAction = isHamburger ? 'hamburgarLink' : 'link'
  dataLayer.add({
    event : event,
    eventAction: eventAction,
    target : text
  })
}
function onOpenHamburgarMenu () {
  dataLayer.add({
    event : 'topNavigationHamburgarMenuOpen',
    eventAction: 'Open'
  })
}

function topNavLayout (size) {
  dataLayer.add({
    topNavLayout : size
  })
}

function logoClick () {
  dataLayer.add({
    event : 'topNavigation',
    eventAction : 'Hem',
    target : 'klickat på logga'
  })
}

function topNavStoreLink (url) {
  dataLayer.add({
    event : 'topNavigationTopLink',
    targetUrl: url
  })
}

function openedSearch () {
  dataLayer.add({
    event: "searchIconClick"
  })
}

function selectedStore (store) {
  store ? dataLayer.add({
    event: 'selectedStoreLoaded',
    selectedStore:{
      id: store.storeId.startsWith("0") ? store.storeId.substring(1) : store.storeId,
      name: store.storeName
    }
  }) : dataLayer.add({
    event: 'selectedStoreLoaded',
    selectedStore: undefined
  })
}

function selectStore () {
  dataLayer.add({
    event: 'selectStoreSelectYourStore'
  })
}

function toggleSelectNewStore (openState) {
  const toggleState = openState ? 'selectStoreOpenDropdown' : 'selectStoreCloseDropdown'
  dataLayer.add({
    event: toggleState
  })
}

function changeOrGoToStore (button) {
  const buttonClicked = button == 'changeStore' ? 'selectStoreChangeStore' : 'selectStoreGoToStore'
  dataLayer.add({
    event: buttonClicked
  })
}

function storeSearch (query, results) {
  dataLayer.add({
    event: 'selectStoreSearch',
    results: results,
    searchTerm: query
  })
}

function selectNewStore (store) {
  dataLayer.add({
    event: 'selectStore',
    selectedStore: {
      id: store.Id.toString(),
      name: store.MarketingName
    }    
  })
}

function storeCloseToMe () {
  dataLayer.add({
    event: 'selectStoreCloseToMe'
  })
}

export default {
  avatarMenuClick,
  menuClick,
  topNavLayout,
  onOpenHamburgarMenu,
  topNavStoreLink,
  openedSearch,
  logoClick,
  selectedStore,
  selectStore,
  changeOrGoToStore,
  storeSearch,
  storeCloseToMe,
  selectNewStore,
  toggleSelectNewStore
}
